module.exports = __webpack_public_path__ + "fba2019b0b09731cc334297955971642.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-Black.ttf
// module id = 1258
// module chunks = 0